// extracted by mini-css-extract-plugin
export default {"container":"FullScreenPage_container__FSSy1"};